import { render, staticRenderFns } from "./os.vue?vue&type=template&id=2e490df6"
import script from "./os.vue?vue&type=script&lang=js"
export * from "./os.vue?vue&type=script&lang=js"
import style0 from "./os.vue?vue&type=style&index=0&id=2e490df6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports